import { api } from '../../service/api.service'

function adminDeleteContract (contractNumber, userId) {
  return api.delete(`/api/contract/admin/${contractNumber}/${userId}`).then((res) => {
  })
}

export { adminDeleteContract }
